/*
 *  Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { NestedValue } from "react-hook-form";
import * as yup from "yup";

export enum FormField {
  NAME = "name",
  DESCRIPTION = "description",
  CONTACT_PERSON_IDS = "contactPersonIds",
  ACTIVE = "active",
}

export type FormData = {
  [FormField.NAME]: string;
  [FormField.DESCRIPTION]: string;
  [FormField.CONTACT_PERSON_IDS]: NestedValue<{ value: string }[]>;
  [FormField.ACTIVE]: boolean;
};

export const schema = yup.object().shape({
  [FormField.NAME]: yup
    .string()
    .required("Workflow Name is a required")
    .min(1, "Minimum 1 characters required")
    .max(50, "Workflow Name limit is 50 characters."),
  [FormField.DESCRIPTION]: yup
    .string()
    .max(255, "Workflow Description limit is 255 characters."),
  [FormField.CONTACT_PERSON_IDS]: yup
    .array()
    .of(
      yup.object({
        value: yup.string(),
      })
    )
    .test({
      name: "required",
      message: "At least one Contact Person is required.",
      test: (array) =>
        (array ?? []).filter(({ value }) => value !== "").length > 0,
    })
    .test({
      name: "required",
      message: "Empty Contact Person fields must be filled or removed.",
      test: (array) =>
        (array ?? []).filter(({ value }) => value === "").length === 0,
    })
    .test({
      name: "unique",
      message: "The same person cannot be selected more than once.",
      test: (array) =>
        (array ?? []).length === new Set(array?.map(({ value }) => value)).size,
    }),
  [FormField.ACTIVE]: yup.boolean().required("Workflow Active is required"),
});
